import React, { useEffect, useState } from "react";
import { TabMenu } from "primereact/tabmenu";
import BannerImg from "../../assets/images/servicebannner.svg";
import Footer from "../../layout/Footer";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchServices,
  fetchSubServices,
} from "../../store/slices/servicesSlice";
import ServiceCard from "../../shared/components/ServiceCard";

export default function Services() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const { services } = useSelector((state) => state.service);
  const { subServices } = useSelector((state) => state.service);

  const [selectedService, setSelectedService] = useState(null);

  useEffect(() => {
    dispatch(fetchServices());

    if (services) {
      const tabItems = services?.map((service) => {
        return {
          label: service?.serviceName,
          _id: service?._id,
        };
      });
      setItems([...tabItems]);
      setSelectedService({
        ...services.find((item) => item._id === tabItems[0]?._id),
      });
    }
  }, [dispatch]);

  const redirectToServiceDetail = (id) => {
    navigate(`/service/${id}`); // Replace with your desired route
  };

  const [activeIndex, setActiveIndex] = useState(0);
  const [items, setItems] = useState([]);

  const onTabChange = (e) => {
    setActiveIndex(e.index);
    const selectedService = services.find((item) => item._id === e.value._id);
    setSelectedService({ ...selectedService });

    dispatch(fetchSubServices(e.value._id));
  };

  return (
    <>
      {/* service banner start */}
      {location.pathname.includes("dashboard") ? (
        <div className="container py-2">
          <h2 className="m-0 text-5xl">Services</h2>
          <hr />
        </div>
      ) : (
        <div
          className="p-text-center service-banner p-my-5"
          style={{
            backgroundImage: `url(${BannerImg})`,
            backgroundSize: "cover",
          }}
        >
          <div className="container">
            <h2 className="m-0 text-center text-5xl text-white">
              Our Services
            </h2>
          </div>
        </div>
      )}

      {/* service banner end */}
      {/* Tab Menu */}
      <div className="p-d-flex py-5 p-jc-center">
        <div className="container">
          <TabMenu
            className="service-tabmenu"
            model={items}
            activeIndex={activeIndex}
            onTabChange={(e) => onTabChange(e)}
          />
          <div className="grid">
            {[...subServices, selectedService].map((service, index) => (
              <>
                <ServiceCard
                  key={service?._id || `service-${index}`} // Added key prop
                  serviceId={service?._id}
                  extraClass="col-12 lg:col-6"
                  navigate={navigate}
                  AfterImg={service?.primaryAfterImage}
                  BeforeImg={service?.primaryBeforeImage}
                  title={service?.serviceName}
                  singleImage={service?.primarySingleImage}
                  detail={service?.description}
                  hasBeforeAfterImage={service?.hasBeforeAfterImages}
                  servicebtn
                  style={{ height: "370px" }}
                  showButton={false}
                  learnMorebtn={() => redirectToServiceDetail(service._id)}
                />
              </>
            ))}
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}
